/* eslint no-fallthrough: "error" */
'use strict'

import {
  // each as _each,
  filter as _filter, // difference as _difference,
  find as _find,
  get as _get,
  includes as _includes,
  isEqual as _isEqual,
  map as _map,
  reject as _reject,
  uniq as _uniq,
  uniqWith as _uniqWith,
} from 'lodash'

/* eslint no-fallthrough: "error" */

/* eslint no-fallthrough: "error" */

let inj

export class OrderFactory {
  constructor(data) {
    Object.assign(this, inj, data, {
      trunk: {},
    })

    this.sendConfirmationEmail = true
  }

  init() {
    return this.$q
      .all([
        this.CompanyService.getEquipments(),
        this.CompanyService.getMaterials(),
        this.CompanyService.getCategories(),
        this.CompanyService.getContractTemplates(),
      ])
      .then((data) => {
        this.trunk.equipments = data[0]
        this.trunk.materials = data[1]
        this.trunk.categories = data[2]
        this.trunk.contractTemplates = data[3]
        return this.$q.resolve(this)
      })
  }

  resetTo(step) {
    switch (step) {
      case 'TASKSITE':
        this.tasksite = this.categories = this.tasksiteContracts = null // falls through
      case 'CATEGORY':
        this.categoryCode = this.containersByTemplates = this.containersByContracts = null // falls through
      case 'CONTRACT':
      case 'TEMPLATE':
        this.contract = this.template = this.lines = this.dates = null // falls through
      case 'LINE':
        this.lineNo = this.quantity = null // falls through
      case 'DATE':
        this.date = null // falls through
    }
  }

  selectTasksite(tasksite) {
    this.resetTo('TASKSITE')

    if (!tasksite) return
    this.tasksite = tasksite
    console.log('setTasksite()', this.tasksite)

    if (this.tasksite.code) {
      this.customer.getTasksiteContracts(this.tasksite.code).then((contracts) => {
        this.tasksiteContracts = _filter(contracts, { status: 'ACCEPTED' })
        this.categories = this.getCategories(contracts)
      })
    } else this.categories = this.getCategories()
  }

  getCategories(contracts = []) {
    const byContracts = _map(contracts, 'categoryCode')
    const byTemplates = _map(this.trunk.contractTemplates, 'categoryCode')
    const all = _uniq(byContracts.concat(byTemplates))
    const categories = _filter(this.trunk.categories, (category) => _includes(all, category.code))
    console.log('getCategories()', categories)
    return categories
  }

  selectCategoryCode(categoryCode) {
    this.resetTo('CATEGORY')

    // Set category code
    this.categoryCode = categoryCode
    console.log('selectCategoryCode() categoryCode', this.categoryCode)

    // Get container collections from contracts
    let filteredContracts = _filter(this.tasksiteContracts, { categoryCode, status: 'ACCEPTED' })
    // Reject all contracts without lines
    filteredContracts = _reject(filteredContracts, (contract) => contract.lines.length === 0)
    const filteredTemplates = _filter(this.trunk.contractTemplates, (template) => {
      // Check category code and if already contained in contracts
      return (
        template.categoryCode === categoryCode &&
        !_find(filteredContracts, {
          equipmentCode: template.equipmentCode,
          materialCode: template.materialCode,
        })
      )
    })

    this.containersByContracts = this.getContainers(filteredContracts)
    this.containersByTemplates = this.getContainers(filteredTemplates)
    console.log('selectCategoryCode() containersByContracts', this.containersByContracts)
    console.log('selectCategoryCode() containersByTemplates', this.containersByTemplates)
  }

  getContainers(contractsOrTemplates) {
    const containers = []

    contractsOrTemplates.forEach((item) => {
      let equipment = _find(this.trunk.equipments, { code: item.equipmentCode })
      let material = _find(this.trunk.materials, { code: item.materialCode })
      if (!equipment || !material) return
      let categoryCode = item.categoryCode
      let iconRef = equipment.iconRef
      containers.push({ equipment, material, iconRef, categoryCode })
    })
    return _uniqWith(containers, _isEqual)
  }

  selectContainer(container) {
    this.resetTo('CONTRACT')
    if (!container) return

    const categoryCode = this.categoryCode
    const equipmentCode = _get(container, 'equipment.code')
    const materialCode = _get(container, 'material.code')

    // @todo Check if multiple contracts
    const contract = _find(this.tasksiteContracts, { equipmentCode, materialCode, categoryCode })
    const template = _find(this.trunk.contractTemplates, { equipmentCode, materialCode, categoryCode })

    if (contract) return this.selectContract(contract)
    else if (template) return this.selectTemplate(template)
  }

  selectContract(contract) {
    this.resetTo('CONTRACT')
    this.contract = contract
    console.log('selectContract()', contract)
    this.lines = this.getLines(contract)
  }

  getLines(contract) {
    return contract ? contract.lines : [{ lineNo: 'new', equipmentType: 1, description: 'Zustellung' }] // Fake
  }

  selectTemplate(template) {
    this.resetTo('TEMPLATE')
    this.template = template
    console.log('selectTemplate()', template)
    this.lines = this.getLines()
  }

  selectLineNo(no) {
    this.resetTo('LINE')
    this.lineNo = no
    console.log('selectLineNo()', this.lineNo)

    if (this.contract) {
      this.customer.getDates(this.contract.taskSiteCode, this.contract.no, this.lineNo).then((dates) => {
        console.log('getDates()', dates)
        this.dates = dates
      })
    } else if (this.template) {
      this.CompanyService.getDates(this.tasksite.postcode).then((dates) => {
        console.log('getDates()', dates)
        this.dates = dates
      })
    }
  }

  setDate(date) {
    this.resetTo('DATE')
    if (!date) return
    this.date = date
  }

  send() {
    if (this.contract) return this.postOrder()
    else if (this.tasksite.code && this.template) return this.postContract()
    else if (!this.tasksite.code && this.template) return this.postTasksite()
  }

  postOrder() {
    const data = {
      contractId: this.contract.no,
      lineNo: this.lineNo,
      taskDate: this.date,
      comment: this.comment || '',
      quantity: this.quantity.toString(),
      sendEmail: this.sendConfirmationEmail,
      contactEmail: this.contactEmail || undefined,
      startingTime: this.startingTime,
      finishingTime: this.finishingTime,
    }
    console.log('postOrder()', data)
    return this.customer.createOrder(this.tasksite.code, data)
  }

  postContract() {
    const data = {
      templateCode: this.template.code,
      templateVariant: this.template.variant,
      quantity: this.quantity.toString(),
      taskDate: this.date,
      comment: this.comment || '',
      extDocNo: this.extDocNo || '',
      sendEmail: this.sendConfirmationEmail,
      contactEmail: this.contactEmail || undefined,
      startingTime: this.startingTime,
      finishingTime: this.finishingTime,
    }
    console.log('postContract()', data)
    return this.customer.createContract(this.tasksite.code, data)
  }

  postTasksite() {
    const data = {
      name: this.tasksite.name,
      name2: this.tasksite.name2 || '',
      address: this.tasksite.address,
      postcode: this.tasksite.postcode,
      city: this.tasksite.city,
      phone: this.tasksite.phone || '',
      templateCode: this.template.code,
      templateVariant: this.template.variant || '',
      quantity: this.quantity.toString(),
      taskDate: this.date,
      comment: this.comment || '',
      extDocNo: this.extDocNo || '',
      sendEmail: this.sendConfirmationEmail,
    }
    console.log('postTasksite()', data)
    return this.customer.createTasksite(data)
  }

  static factory($q, $http, CompanyService) {
    'ngInject'
    inj = { $q, $http, CompanyService }
    return OrderFactory
  }
}



// WEBPACK FOOTER //
// ./app/shared/services/order.factory.js